import { Checkbox } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import React from 'react';
import './nav-section-mobile.less';
import FilterArrow from '../../../assets/filterArrow.svg';

interface IFilterOption {
  label: string;
  value: string;
  hide?: boolean;
}

interface IFilterCategory {
  title: string;
  defaultItem?: string;
  options: IFilterOption[];
}

interface IFilterBarProps {
  settings: any;
  onCheckedListChange?: (checkedList: CheckboxValueType[]) => void;
}

const FilterBar: React.FunctionComponent<IFilterBarProps> = ({
  settings,
  onCheckedListChange,
}) => {
  const filterCategories: IFilterCategory[] = (
    settings?.filterCategories || []
  ).map((category: IFilterCategory) => ({
    ...category,
    options: (category.options || []).filter((itm) => !itm.hide),
  }));

  const options = filterCategories.flatMap((category) => category.options);

  const [checkedList, setCheckedList] = React.useState<CheckboxValueType[]>(
    options.map((option) => option.value)
  );

  const [indeterminate, setIndeterminate] = React.useState(false);
  const [checkAll, setCheckAll] = React.useState(true);
  const [showFilter, setShowFilter] = React.useState(false);
  const handleFilterClick = () => {
    setShowFilter(!showFilter);
  };
  const handleFilterSubmit = () => {
    setShowFilter(false);
  };

  React.useEffect(() => {
    if (showFilter) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showFilter]);

  React.useEffect(() => {
    if (onCheckedListChange) {
      onCheckedListChange(checkedList);
    }
  }, [checkedList, onCheckedListChange]);

  const onChange = (list: CheckboxValueType[]) => {
    console.log('checkedList:', list);
    setCheckedList(list);
    setIndeterminate(Boolean(list.length) && list.length < options.length);
    setCheckAll(list.length === options.length);
  };

  const onCheckAllChange = (e: any) => {
    const allValues = options.map((option) => option.value);
    setCheckedList(e.target.checked ? allValues : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  const onCategoryChange = (
    categoryOptions: IFilterOption[],
    list: CheckboxValueType[]
  ) => {
    const categoryValues = categoryOptions.map((option) => option.value);
    const rest = checkedList.filter(
      (value) => !categoryValues.includes(String(value))
    );
    onChange([...rest, ...list]);
  };

  return (
    <div className="filter-bar">
      <div className="filter" onClick={handleFilterClick}>
        {settings?.navTitle}
        <img className="filterArrow" src={FilterArrow} alt="" />
      </div>

      {showFilter && (
        <>
          <div
            className="filter-submit"
            onClick={() => {
              handleFilterSubmit();
            }}
          >
            {settings?.navSubmit}
          </div>
          <div className="filter-down">
            <div className="filter-down-body">
              <Checkbox
                indeterminate={indeterminate}
                onChange={onCheckAllChange}
                checked={checkAll}
              >
                {settings?.navSelectAll}
              </Checkbox>
              <div className="sub-filter">
                {filterCategories.map((category) => {
                  const categoryValues = category.options.map(
                    (option) => option.value
                  );
                  const categoryChecked = checkedList.filter((value) =>
                    categoryValues.includes(String(value))
                  );

                  return (
                    <div key={category.title} className="filter-category">
                      <div className="filter-item">{category.title}</div>
                      {category.defaultItem && (
                        <div className="ant-checkbox-wrapper ant-checkbox-wrapper-checked default-item">
                          <span className="ant-checkbox ant-checkbox-checked">
                            <span className="ant-checkbox-inner" />
                          </span>
                          <span>{category.defaultItem}</span>
                        </div>
                      )}
                      <Checkbox.Group
                        options={category.options}
                        value={categoryChecked}
                        onChange={(list) =>
                          onCategoryChange(category.options, list)
                        }
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FilterBar;
